import { Box } from '@mui/material';
import { ColoredAvatar, Tooltip } from 'src/components';

export const AvatarCell = ({
  fullName,
  subTitle,
}: {
  fullName: string;
  subTitle?: string;
}) => {
  const tooltipText = subTitle ? `${fullName}\n${subTitle}` : fullName;
  if (!tooltipText) {
    return (
      <ColoredAvatar
        name={fullName}
        sx={{
          height: '1.25rem',
          width: '1.25rem',
        }}
      />
    );
  }

  return (
    <Tooltip
      sx={{
        display: 'flex',
        alignItems: 'center',
        whiteSpace: 'pre-line',
        textAlign: 'center',
      }}
      title={<span style={{ whiteSpace: 'pre-line' }}>{tooltipText}</span>}
    >
      {/* empty box is needed for tooltip */}
      <Box>
        <ColoredAvatar
          name={fullName}
          sx={{
            height: '1.25rem',
            width: '1.25rem',
          }}
        />
      </Box>
    </Tooltip>
  );
};
